import React from 'react';

import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  backButton: {
    alignItems: 'center',
    color: theme.palette.primary.main,
    display: 'flex',
    lineHeight: 1,
    padding: 4,
    textAlign: 'center',
    textTransform: 'none',
  },
  backIcon: {
    fontSize: '1.2rem',
    marginRight: theme.spacing(1),
  },
}));

const BackButton = ({ route = '/', goBackHistory = false, marginBottom = 10, color = null }) => {
  const classes = useStyles();

  const history = useHistory();

  const handleBackToWorklist = () => {
    if (goBackHistory && window.history.length > 2) {
      history.goBack();
    } else {
      history.replace(route);
    }
  };

  return (
    <Button className={classes.backButton} onClick={handleBackToWorklist} role="button" style={{ color, marginBottom }}>
      <ArrowBack className={classes.backIcon} />
      <Typography variant="body1">Back</Typography>
    </Button>
  );
};

export default BackButton;
